import { UploadedFileInfo } from 'src/types';

// S3 key format: <ingress|completed>/<customer>/<fileName>/<fileName>_<timestamp>.xlsx
const getFileNameFromFileKey = (fileKey: string) =>
  fileKey.split('/')[2] || fileKey;

// Older c_ingested_files rows can have an empty file_name
export const getUploadedFileName = (file: UploadedFileInfo) =>
  file.fileName || getFileNameFromFileKey(file.fileKey);
